<template>
  <div>
    <label-field :for="field.id" :field="field" :label-error="textBoxError" />
    <div
      class="dateOfBirth flex"
      @keyup.capture="updateValue"
      @keydown.capture="preventInvalidCharacters"
    >
      <div class="flex flex-column">
        <label for="month" class="hideForScreenReader">Month</label>
        <input
          id="month"
          autocomplete="off"
          v-if="showMonth"
          ref="month"
          v-model="month"
          class="dateOfBirth__input dateOfBirth__input--month"
          type="number"
          placeholder="MM"
          @input="updateMonth"
          @blur="month = month.substring(0, 2).padStart(2, 0)"
          @focusout="checkTextBoxError"
          :disabled="disabled"
          :required="field.required"
        />
        <field-descriptor description="Month" />
      </div>
      <div class="flex flex-column">
        <label for="day" class="hideForScreenReader">Day</label>
        <input
          id="day"
          autocomplete="off"
          v-if="showDay"
          ref="day"
          v-model="day"
          class="dateOfBirth__input dateOfBirth__input--day"
          type="number"
          placeholder="DD"
          @input="updateDay"
          @blur="day = day.substring(0, 2).padStart(2, 0)"
          @focusout="checkTextBoxError"
          :disabled="disabled"
          :required="field.required"
        />
        <field-descriptor description="Day" />
      </div>
      <div class="flex flex-column">
        <label for="year" class="hideForScreenReader">Year</label>
        <input
          id="year"
          autocomplete="off"
          v-if="showYear"
          ref="year"
          v-model="year"
          class="dateOfBirth__input dateOfBirth__input--year"
          type="number"
          placeholder="YYYY"
          @blur="year = year.padStart(4, 0)"
          @focusout="checkTextBoxError"
          :disabled="disabled"
          :required="field.required"
        />
        <field-descriptor description="Year" />
      </div>
    </div>
  </div>
</template>

<script>
  import LabelField from "./LabelField";
  import FieldDescriptor from "./FieldDescriptor";

  export default {
    name: "DateOfBirthField",
    components: { FieldDescriptor, LabelField },
    props: {
      value: {
        type: [Number, String],
        required: true,
      },
      showDay: {
        type: Boolean,
        default: true,
      },
      showMonth: {
        type: Boolean,
        default: true,
      },
      showYear: {
        type: Boolean,
        default: true,
      },
      field: {
        id: "",
        label: "",
        required: false,
        value: "",
        placeholder: "",
      },
      showError: {
        value: false,
      },
      disabled: Boolean,
    },
    data() {
      return {
        day: `${this.value ? new Date(this.value).getDate() : ``}`,
        month: `${this.value ? new Date(this.value).getMonth() + 1 : ``}`,
        year: `${this.value ? new Date(this.value).getFullYear() : ``}`,
        textBoxError: false,
      };
    },
    watch: {
      year(current, prev) {
        if (current === "" || current === "0000") {
          return;
        }

        if (current.length > 4 || current < 1) {
          this.year = prev;
        } else if (current > 999) {
          this.updateValue();
          this.$emit("year");
        }
      },
      showError() {
        this.textBoxError =
          this.showError && this.field.required && !this.value.trim();
      },
    },
    methods: {
      updateDay() {
        if (!this.day.length || parseInt(this.day, 10) < 4) return;
        if (this.showYear) this.$refs.year.select();
        else if (this.showMonth) this.$refs.month.select();
      },
      updateMonth() {
        if (!this.month.length || parseInt(this.month, 10) < 2) return;
        if (this.showYear) this.$refs.day.select();
      },
      updateValue() {
        const dateObject = {
          month: this.month,
          day: this.day,
          year: this.year,
        };

        this.$emit("input", dateObject);
      },
      preventInvalidCharacters(e) {
        if (["-", "+", "e"].includes(e.key)) {
          e.preventDefault();
        }
      },
      checkTextBoxError() {
        this.textBoxError = !!(this.field.required && !this.value.trim());
      },
    },
  };
</script>

<style scoped lang="scss">
  input[type="number"] {
    box-sizing: border-box;
    padding: 8px;
    font-size: 12px;
    background: #fff;
    color: #000;
    border: 1px solid #d4d8db;
    text-align: left;
    -webkit-appearance: textfield;

    &::placeholder {
      color: #aeb7bf;
    }
  }

  .hideForScreenReader {
    display: none;
  }

  // What's with the selector syntax? Answer: http://getbem.com/introduction/
  .dateOfBirth {
    &__input {
      text-align: center;

      // Hide the spinner button in Chrome, Safari and Firefox.
      &::-webkit-inner-spin-button {
        display: none; // 1
      }

      &--day,
      &--month {
        height: 30px;
        margin-right: 20px;
        margin-bottom: 0px;
        width: 52px;
      }

      &--year {
        height: 30px;
        margin-bottom: 0px;
        width: 52px;
      }

      &:focus {
        border-color: #007fad;
        box-shadow: 0 2px 6px rgba(0, 174, 239, 0.25);
        outline: 0;
      }
    }
  }
</style>
